import React, { useState } from 'react';
// chakra imports
import { Box, Flex, Stack } from '@chakra-ui/react';
//   Custom components
import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';
// import SidebarCard from 'components/sidebar/components/SidebarCard';

// FUNCTIONS

function SidebarContent(props) {
  const { routes } = props;
  const { sidebarPos, mouseOver } = props;

  // console.log(sidebarPos);
  // SIDEBAR
  return (
    <Flex
      // bgColor='red'
      direction='column'
      height='100%'
      pt='35px'
      // borderRadius='30px'
    >
      <Brand
        sidebarPos={sidebarPos}
        mouseOver={mouseOver}
      />
      <Stack
        direction='column'
        mb='auto'
        mt={sidebarPos || mouseOver ? '8px' : '10px'}>
        <Box
          // bgColor='yellow'
          ps='8px'
          pe='16px'>
          <Links
            routes={routes}
            sidebarPos={sidebarPos}
            mouseOver={mouseOver}
          />
        </Box>
      </Stack>

      <Box
        ps='20px'
        pe={{ md: '16px', '2xl': '0px' }}
        mt='60px'
        mb='40px'
        borderRadius='30px'>
        {/* <SidebarCard /> */}
      </Box>
    </Flex>
  );
}

export default SidebarContent;
